import { connect } from 'react-redux';

import {
	getBookingGuidelines,
	onBookingGuidelinesViewSubmit,
	getHkustPoints,
	getStaffs,
	getFavoriteDestinations,
	getApplicationPreviousBookings,
	onSubmit,
	createFavoriteLocation,
	cancelApplicationTripById,
	cancelAllTrips,
	resetMeta,
	resetPage
} from '../../../actions/ApplicationPage/BookingApplication';

import ApplicationBasicPage from './ApplicationBasicPage';

const mapsStateToProps = state => ({
	pageProps: state.applicationDetailPage.applicationBasicPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getBookingGuidelines() {
		dispatch(getBookingGuidelines());
	},
	onBookingGuidelinesViewSubmit(appllicationType) {
		dispatch(onBookingGuidelinesViewSubmit(appllicationType));
	},
	getHkustPoints: () => {
		dispatch(getHkustPoints());
	},
	getStaffs: () => {
		dispatch(getStaffs());
	},
	getApplicationPreviousBookings: () => {
		dispatch(getApplicationPreviousBookings());
	},
	getFavoriteDestinations: () => {
		dispatch(getFavoriteDestinations());
	},
	onSubmit: options => {
		dispatch(onSubmit(options));
	},
	createFavoriteLocation: options => {
		dispatch(createFavoriteLocation(options));
	},
	cancelApplicationTripById: (applicationTripId, body) => {
		dispatch(cancelApplicationTripById(applicationTripId, body));
	},
	cancelAllTrips: body => {
		dispatch(cancelAllTrips(body));
	},
	resetMeta: () => {
		dispatch(resetMeta());
	}
});

export default connect(mapsStateToProps, mapsDispatchToProps)(ApplicationBasicPage);
